export { default as reducer } from './ad.ducks';



// WEBPACK FOOTER //
// ./src/routes/Ad/index.ts